import AuthorityMasterLayout from './AuthorityMasterLayout';

export default AuthorityMasterLayout;
